import React from 'react';
import { useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { useUppyEvent, Dashboard } from '@uppy/react';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.css';
import { uppyBaseOptions, useUppyXhr } from '@/utils/uppy';
import { formatBytes } from '@/utils/fileHelper';
import { collectionLogoEndpoint } from '@/constants/urls';
import image from '../hooks/image';

const CollectionUploadLogo = ({
  allowedExtensions,
  category,
  checkImage,
  code,
  imageAdded,
  isEditing,
  isNew,
  maxFileSize,
  saveImage,
  saveImageError,
  saveImageSuccess,
  saveStatus,
  uppyId,
}) => {
  const intl = useIntl();
  const xhrOptions = React.useMemo(() => ({
    id: uppyId,
    endpoint: collectionLogoEndpoint(code),
  }), [uppyId]);

  const baseOptions = React.useMemo(() => ({
    ...uppyBaseOptions,
    autoProceed: false,
    allowMultipleUploads: false,
    restrictions: {
      maxFileSize,
      minFileSize: 1,
      maxTotalFileSize: maxFileSize,
      maxNumberOfFiles: 1,
      allowedFileTypes: allowedExtensions,
    },
  }), [uppyId]);

  const uppy = useUppyXhr(baseOptions, xhrOptions);

  useUppyEvent(uppy, 'upload', () => {
    if (isNew) return;

    saveImage(category, code);
  });
  useUppyEvent(uppy, 'file-added', () => { imageAdded(category, code, true); });
  useUppyEvent(uppy, 'complete', (result) => {
    if (isNew || !result) return;

    if (result.successful.length) {
      saveImageSuccess(code, uuidv4());
    }
    if (result.failed.length) {
      saveImageError(category, code, result.failed[0].error);
    }
  });

  image.useCheckImage(checkImage, category, code, saveStatus, uppyId);
  if (!isEditing) {
    return null;
  }

  return (
    <div className="aridhia-uppy-dashboard">
      <Dashboard
        uppy={uppy}
        proudlyDisplayPoweredByUppy={false}
        hideUploadButton
        width={375}
        height={275}
        note={intl.formatMessage({ id: 'collection.upload.logo.notes' }, { size: formatBytes(maxFileSize, false) })}
        locale={{
          strings: {
            browseFiles: intl.formatMessage({ id: 'upload.dashboard.browse' }),
            dropPasteFiles: `${intl.formatMessage({ id: 'upload.dashboard.drop.collection.logo' })} %{browse}`,
          },
        }}
      />
    </div>
  );
};

export default CollectionUploadLogo;
